/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Spinner, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDeleteLeft, faEarthAfrica } from "@fortawesome/free-solid-svg-icons";
import useViewCompanies from "./useViewCompanies";
import Header from "../../Common/Header";
import CompanySearch from "./components/CompanySearch";
import MainLayout from "../MainLayout";
export default (props) => {
  const {
    loading,
    allCompanies,
    showSearch,
    searchInputRef,
    companiesLoading,
    companySearch,
    onSearch,
    companyNavigation,
    onSearchInputChange,
  } = useViewCompanies(props);

  return (
    <MainLayout activeMenuItem="companies" pageName="All Companies">
      <Container>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : allCompanies && allCompanies.length > 0 ? (
          <div>
            <div className="search d-flex align-items-center justify-content-between">
              <div className="company-search mw-25 ml-auto">
                {/* <div className="search-box input-group border rounded bg-grey">
                  <input
                    type="text"
                    className="form-control border-0 bg-transparent"
                    placeholder="Search"
                    onChange={(e) => onSearchInputChange(e)}
                    ref={searchInputRef}
                    style={{ height: '48px' }}
                  />
                  <div className="input-group-append">
                    {showSearch ? (
                      <button
                        className="btn p-2"
                        type="button"
                        onClick={onSearch}
                      >
                        <FontAwesomeIcon
                          icon={faDeleteLeft}
                          className="ml-2"
                        />
                      </button>
                    ) : (
                      <button className="btn p-2" type="button">
                        <img
                          src="../assets/images/search-icon.png"
                          alt="search"
                        />
                      </button>
                    )}
                  </div>
                </div> */}
              </div>
            </div>

            {showSearch ? (
              <CompanySearch
                companySearch={companySearch}
                companiesLoading={companiesLoading}
                companyNavigation={companyNavigation}
              />
            ) : (
              <div className="px-5 row">
                {/* <div className="col-md-4 col-lg-3 col-xl-2 pr-1">
                  <h2 className="mb-3 py-md-1 d-inline-block mr-2">Job Filter</h2><span className="text-primary font-weight-medium cursor-pointer">Clear all</span>
                  <div className="h-100">
                    <div className=" p-3 bg-grey border-radius-10 border">
                      <div className="d-flex font-weight-medium justify-content-between align-items-center mb-4">
                        <h3 className="font-weight-medium">Company Field</h3>
                        <p className="text-primary mb-0">Clear</p>
                      </div>
                      <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="rememberCheck"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rememberCheck"
                          >
                            Information Technology
                          </label>
                        </div>

                        <p className="text-muted">255</p>
                      </div>
                      <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="rememberCheck"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rememberCheck"
                          >
                            Business
                          </label>
                        </div>

                        <p className="text-muted">124</p>
                      </div>
                      <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="rememberCheck"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rememberCheck"
                          >
                           Medicine
                          </label>
                        </div>

                        <p className="text-muted">2404</p>
                      </div>
                    </div>
                    <div className=" p-3 bg-grey border-radius-10 border mt-3">
                      <div className="d-flex font-weight-medium justify-content-between align-items-center mb-4">
                        <h3 className="font-weight-medium">Company Location</h3>
                        <p className="text-primary mb-0">Clear</p>
                      </div>
                      <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="rememberCheck"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rememberCheck"
                          >
                           India
                          </label>
                        </div>

                        <p className="text-muted">255</p>
                      </div>
                      <div className="d-flex pb-2 justify-content-between  font-weight-medium fs-14">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="rememberCheck"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rememberCheck"
                          >
                            United States
                          </label>
                        </div>
                        <p className="text-muted">2404</p>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-md-8 col-lg-9 col-xl-10">
                  <h2 className="d-inline-block mb-4 mt-3 mt-md-0">
                    {" "}
                    Showing {allCompanies.length} companies
                  </h2>
                  <div className="row">
                    {allCompanies &&
                      Array.isArray(allCompanies) &&
                      allCompanies.map((data, index) => (
                        <div className="col-md-6 col-xl-4 mb-4">
                          <div className="p-4 bg-white border position-relative h-100 border-radius-10 shadow-2">
                            <div className="upper border-bottom">
                              <div className="d-flex mb-3 align-items-start">
                                <img
                                  src={
                                    data?.logo
                                      ? data.logo
                                      : "/assets/images/building-placeholder.png"
                                  }
                                  alt="company logo"
                                  className="border-radius-10 mr-3"
                                  style={{ width: "48px", height: "48px" }}
                                />
                                <div className="job-info">
                                  <h3 className="font-weight-medium mb-1 text-capitalize cursor-pointer text-primary">
                                    {data?.name}
                                  </h3>
                                  <p className="mb-1 fs-14 text-capitalize">
                                    {data?.industry ? (
                                      <>
                                        <span className="text-muted">
                                          {data?.industry}
                                        </span>
                                      </>
                                    ) : null}
                                  </p>
                                </div>
                              </div>
                              {data?.about ? (
                                <>
                                  <p className="text-muted">{data?.about}</p>
                                </>
                              ) : null}

                              <div className="d-flex align-items-center fs-smallest text-primary mb-3 flex-wrap">
                                {data?.industry ? (
                                  <>
                                    <p className="mb-0 bg-light-blue text-capitalize  rounded-lg py-1 px-3 mr-2 mb-2">
                                      {data?.industry}
                                    </p>
                                  </>
                                ) : null}
                                {data?.size ? (
                                  <>
                                    <p className="mb-0 bg-light-blue text-capitalize rounded-lg py-1 px-3 mr-2 mb-2">
                                      {data?.size} employees
                                    </p>
                                  </>
                                ) : null}

                                <p className="mb-0 bg-light-blue text-capitalize bg-primary-light rounded-lg py-1 px-3 mr-2 mb-2">
                                  Georgia
                                </p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mt-3">
                              <div className="job-bottom d-flex align-items-center justify-content-between w-100">
                                {data?.url ? (
                                  <>
                                    <div className="text-primary d-flex align-items-center">
                                      <FontAwesomeIcon
                                        icon={faEarthAfrica}
                                        className="mr-2"
                                      />
                                      <a
                                        href={data?.url}
                                        target="_blank"
                                        className="font-weight-medium mb-0"
                                      >
                                        Visit Website
                                      </a>
                                    </div>
                                  </>
                                ) : null}

                                <button
                                  className="btn btn-primary ml-auto py-2"
                                  onClick={() => companyNavigation(data?.id)}
                                >
                                  View
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            className="d-flex align-items-center
          justify-content-center flex-column py-4"
          >
            <img src="/assets/images/empty-state.svg" alt="empty" />
            <h4 className="font-weight-bold mb-1 mt-2">No Companies Found !</h4>
          </div>
        )}
      </Container>
    </MainLayout>
  );
};
